"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateUnpaidOrderReceiptHTMLV1 = void 0;
const shared_1 = require("@getgreenline/shared");
const utils_1 = require("./utils");
const lodash_1 = require("lodash");
const generateReceiptHTMLV2_1 = require("./generateReceiptHTMLV2");
const generateUnpaidOrderReceiptHTMLV1 = (data) => {
    const { companyName, locationName, payment, paymentQueueData, receiptSettings, fontSize } = data;
    const { subHeader, description, address, footer, showSku } = receiptSettings;
    const totalDepositFee = payment.paymentLines.reduce((a, pl) => (pl.depositFee || 0) + a, 0);
    const headerText = (0, generateReceiptHTMLV2_1.getCustomReceiptHeader)(receiptSettings, companyName, locationName);
    return `
  <div id='print-section' style='padding-left: 10px; padding-right: 10px;'>
    <table style='width: 100%; border: none; border-width: 0; border-collapse: collapse; padding: 0;${fontSize ? `font-size: ${fontSize};` : ''}'>
      <tbody>
        <tr style='font-size: 1.5em; text-align:center; width: 100%'>
          <td colspan=2 style='white-space: pre-line; overflow-wrap: break-word; font-weight: bold; word-break: break-word'>${headerText}</td>
        </tr>
        ${subHeader
        ? `
          <tr style='text-align:center;'>
            <td colspan=2 style='white-space: pre-line; overflow-wrap: break-word; word-break: break-word; font-weight: bold'>${subHeader}</td>
          </tr>
          `
        : ''}
        ${description
        ? `
          <tr style='text-align:center;'>
            <td colspan=2 style='white-space: pre-line; overflow-wrap: break-word; word-break: break-word'>${description}</td>
          </tr>
          `
        : ''}
        ${address
        ? `
          <tr style='text-align:center;'>
            <td colspan=2 style='white-space: pre-line; overflow-wrap: break-word; word-break: break-word'>${address}</td>
          </tr>
          `
        : ''}
      </tbody>
    </table>

    

    <table style='margin-top: 1.5rem; width: 100%; border: none; border-width: 0; border-collapse: collapse; padding: 0;${fontSize ? `font-size: ${fontSize};` : ''}'>
      <tbody>
        <tr>
          <td colspan=2 style='padding-bottom: 0.5rem; font-size: 1.2em; text-align: right'><b>UNPAID</b></td>
        </tr>
        <tr>
          <td style='border-top: solid; border-width: 1px; '>Created</td>
          <td style='border-top: solid; border-width: 1px;  text-align: right'>${(0, shared_1.dayjs)(paymentQueueData.createDate).format(shared_1.DayjsFormat.RECEIPT_LOCALIZED_DATETIME)}</td>
        </tr>
            
        ${paymentQueueData.customerName
        ? `
              <tr>
                <td style='border-top: solid; border-width: 1px; '>Customer</td>
                <td style='border-top: solid; border-width: 1px;  text-align: right'>${paymentQueueData.customerName}</td>
              </tr>
            `
        : ''}

      </tbody>
    </table>

    <table style='margin-top: 1.5rem; width: 100%; border: none; border-width: 0; border-collapse: collapse; padding: 0;${fontSize ? `font-size: ${fontSize};` : ''}'>
        <tbody>
          <tr>
            <td><b>Product</b></td>
            <td style='text-align: right'><b>Qty</b></td>
            <td style='text-align: right'><b>Price</b></td>
          </tr>
          ${payment.paymentLines
        .map((paymentLine) => {
        let unitString;
        if (paymentLine.inventorySubtracted) {
            if (paymentLine.unit === 'gram') {
                unitString = `${paymentLine.inventorySubtracted} g`;
            }
            else {
                unitString = paymentLine.inventorySubtracted.toString();
            }
        }
        else {
            unitString = paymentLine.units.toString();
        }
        if (paymentLine.type === 'discount' || paymentLine.type === 'loyalty') {
            return `
                <tr>
                  <td style='border-top: solid; border-width: 1px;'>${paymentLine.productName}</td>
                  <td style='border-top: solid; border-width: 1px; text-align: right'></td>
                  <td style='border-top: solid; border-width: 1px; text-align: right; word-break: keep-all;'>${(0, utils_1.formatCurrencyFromCents)(paymentLine.discountPrice)}</td>
                </tr>
                `;
        }
        return `
                <tr>
                  <td style='border-top: solid; border-width: 1px; '>
                    <div class='d-flex' style='flex-direction: column;'>
                      ${showSku && !!paymentLine.sku ? `<div>${paymentLine.sku}</div>` : ''}
                      <div>${paymentLine.productName}</div>
                      ${paymentLine.shortDescription
            ? `<div style='font-size: .9em'>${paymentLine.shortDescription}</div>`
            : ''}
                    </div>
                  </td>
                  <td style='border-top: solid; border-width: 1px; padding-right:.5rem; text-align: right'>${unitString}</td>
                  <td style='border-top: solid; border-width: 1px;  text-align: right; word-break: keep-all;'>${(0, utils_1.formatCurrencyFromCents)(paymentLine.price)}</td>
                </tr>
                ${paymentLine.discountPrice
            ? `
                  <tr>
                    <td>${paymentLine.discountMessage}</td>
                    <td></td>
                    <td style='text-align: right; word-break: keep-all;'>${(0, utils_1.formatCurrencyFromCents)(paymentLine.discountPrice)}</td>
                  </tr>
                  `
            : ''}
                ${paymentLine.depositFee
            ? `
                  <tr>
                    <td>Deposit Fee</td>
                    <td></td>
                    <td style='text-align: right; word-break: keep-all;'>${(0, utils_1.formatCurrencyFromCents)(paymentLine.depositFee)}</td>
                  </tr>
                  `
            : ''}
                `;
    })
        .join('')}
         </tbody>
        </table>


      <table style='margin-top: 1.5rem; width: 100%; border: none; border-width: 0; border-collapse: collapse; padding: 0;${fontSize ? `font-size: ${fontSize};` : ''}'>
        <tbody>
          <tr>
            <td style='width: 20%'></td>
            <td style='border-top: solid; border-width: 1px; '>Subtotal</td>
            <td style='border-top: solid; border-width: 1px;  text-align: right'>${(0, utils_1.formatCurrencyFromCents)(paymentQueueData.subTotal)}</td>
          </tr>
          ${(0, lodash_1.chain)(payment.taxPaymentLines)
        .groupBy('taxId')
        .map((objs, key) => ({
        id: key,
        name: objs[0].displayName || (0, utils_1.getTaxNameByID)(objs[0].taxId) || 'Tax',
        totalAmount: objs.reduce((prev, next) => prev + next.amount, 0),
    }))
        .value()
        .map((aggregatedTax) => `
                  <tr>
                    <td style='width: 20%'></td>
                    <td style='border-top: solid; border-width: 1px; '>${aggregatedTax.name}</td>
                    <td style='border-top: solid; border-width: 1px;  text-align: right'>${(0, utils_1.formatCurrencyFromCents)(aggregatedTax.totalAmount)}</td>
                  </tr>
                `)
        .join('')}
          ${totalDepositFee
        ? `
            <tr>
              <td style='width: 20%'></td>
              <td style='border-top: solid; border-width: 1px; '>Deposit Fee</td>
              <td style='border-top: solid; border-width: 1px;  text-align: right'>${(0, utils_1.formatCurrencyFromCents)(totalDepositFee)}</td>
            </tr>
            `
        : ''}
          <tr style='font-weight: 600;'>
            <td style='width: 20%'></td>
            <td style='border-top: solid; border-width: 1px; '>Total</td>
            <td style='border-top: solid; border-width: 1px;  text-align: right'>${(0, utils_1.formatCurrencyFromCents)(payment.total)}</td>
          </tr>
        </tbody>
      </table>



      

      <table style='margin-top: 1.5rem; margin-bottom: 1.5rem; width: 100%; border: none; border-width: 0; border-collapse: collapse; padding: 0;${fontSize ? `font-size: ${fontSize};` : ''}'>
        <tbody>
          ${footer
        ? `
            <tr style='text-align: center;'>
              <td colspan=2 style='border-top: solid; border-width: 1px;  margin-bottom: 20px; white-space: pre-line; overflow-wrap: break-word; word-break: break-word'>${footer}</td>
            </tr>
            `
        : ''}


          
          
        </tbody>
      </table>
 
  </div>
  </div>
  `;
};
exports.generateUnpaidOrderReceiptHTMLV1 = generateUnpaidOrderReceiptHTMLV1;
//# sourceMappingURL=generateUnpaidOrderReceiptHTMLV1.js.map